// 后端时间字段同时存在两种形态:
// - BaseModel.CreatedAt / UpdatedAt 是 Unix 秒 (number, 例如 1782202911) — 直接 new Date(n) 会被当毫秒, 显示成 1970 年
// - ApprovalTask.DueAt / DecidedAt 是 MySQL datetime 字符串 (例如 "2026-06-23 11:00:00")
// 这个工具统一兜底, 给一个 "YYYY-MM-DD HH:mm" 的展示串.

/** 把后端时间字段 (Unix 秒数字 或 datetime 字符串) 格式化成 "YYYY-MM-DD HH:mm". 空值返回 '—'. */
export function formatTime(v: unknown): string {
    if (v == null || v === '') return '—';
    const n = typeof v === 'number' ? v : Number(v);
    // 数字: < 1e12 视为 Unix 秒, 否则视为毫秒 (兼容前后端时间戳风格).
    const d =
        !isNaN(n) && n > 0
            ? new Date(n < 1e12 ? n * 1000 : n)
            : new Date(String(v));
    if (isNaN(d.getTime())) return String(v);
    const pad = (x: number) => String(x).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
